var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53837FCC-2B3B-4D7B-A57F-8B9E6867801D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gydytoj\\u0173-s\\u0105ra\\u0161as",
    transform: "translate(-1182.000000, -526.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1179.000000, 520.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,5 L7,9 L11,9 L11,10 L7,10 L7,14 L6,14 L6,10 L2,10 L2,9 L6,9 L6,5 L7,5 Z",
    id: "delete",
    transform: "translate(6.500000, 9.500000) rotate(-315.000000) translate(-6.500000, -9.500000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.78285a511e4b9da2c9ee47669aa191b4.svg";
export { ForwardRef as ReactComponent };